import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface AuthStore {
  token: string | null;
  setToken: (token: string | null) => void;
  clearToken: () => void;
}

export const useAuthStore = create(
  persist<AuthStore>(
    (set) => ({
      token: null,
      setToken: (token) => set({ token }),
      clearToken: () => set({ token: null }),
    }),
    {
      name: "centra-client-token",
    }
  )
);

export const useLocalToken = () => useAuthStore((state) => state.token);
export const useSetLocalToken = () => useAuthStore((state) => state.setToken);
